import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-xxl" }
const _hoisted_2 = {
  class: "row",
  style: {"min-height":"100vh"}
}
const _hoisted_3 = { class: "col-md-9 col-sm-12 mx-auto" }
const _hoisted_4 = { class: "row h-100" }
const _hoisted_5 = { class: "col-md-6 mx-auto" }
const _hoisted_6 = { class: "d-flex align-items-center justify-content-center h-100" }
const _hoisted_7 = { class: "w-100" }
const _hoisted_8 = { class: "authentication-wrapper authentication-basic container-p-y" }
const _hoisted_9 = { class: "authentication-inner w-100" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"app-brand justify-content-center\"><a href=\"/\" class=\"app-brand-link gap-2\"><span class=\"app-brand-text demo text-body fw-bold text-uppercase mb-3\"><img src=\"https://pos-file.phicsart.com/profile_user.png\" alt=\"n/a\" class=\"img-fluid\" style=\"width:80px;height:80px;\"></span></a></div><h4 class=\"mb-2 text-center\">Registration Form</h4>", 2)
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger alert-dismissible",
  role: "alert"
}
const _hoisted_15 = {
  key: 1,
  class: "alert alert-warning alert-dismissible",
  role: "alert"
}
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "form-label"
}, "First Name", -1)
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "form-label"
}, "Last Name", -1)
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Email"),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "*")
], -1)
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "form-label"
}, "Phone", -1)
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "form-label"
}, "National Indentification Number", -1)
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "form-label"
}, "Address", -1)
const _hoisted_28 = { class: "mb-3 form-password-toggle" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Password"),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "*")
], -1)
const _hoisted_30 = { class: "input-group input-group-merge" }
const _hoisted_31 = ["type"]
const _hoisted_32 = { class: "mb-3 form-password-toggle" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Confirm Password"),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "*")
], -1)
const _hoisted_34 = { class: "input-group input-group-merge" }
const _hoisted_35 = ["type"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input",
      type: "checkbox",
      id: "remember-me"
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "form-check-label",
      for: "remember-me"
    }, " Remember Me ")
  ])
], -1)
const _hoisted_37 = { class: "mb-3" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_41 = {
  key: 2,
  class: "visually-show"
}
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "Already have an account?", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, "Login", -1)
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        (_ctx.errorMessages.password)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createTextVNode(_toDisplayString(_ctx.errorMessages.password) + " ", 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-close",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearError('password'))),
                                "aria-label": "Close"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.errorMessages.email)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createTextVNode(_toDisplayString(_ctx.errorMessages.email) + " ", 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-close",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('email'))),
                                "aria-label": "Close"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("form", {
                          id: "formAuthentication",
                          class: "mb-3",
                          onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onRegistration && _ctx.onRegistration(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "firstname",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registrationForm.firstname) = $event)),
                              placeholder: "Enter yout First Name",
                              required: ""
                            }, null, 512), [
                              [_vModelText, _ctx.registrationForm.firstname]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "lastname",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registrationForm.lastname) = $event)),
                              placeholder: "Enter your Last Name"
                            }, null, 512), [
                              [_vModelText, _ctx.registrationForm.lastname]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _withDirectives(_createElementVNode("input", {
                              type: "email",
                              class: "form-control",
                              id: "email",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registrationForm.email) = $event)),
                              placeholder: "Enter your email",
                              required: ""
                            }, null, 512), [
                              [_vModelText, _ctx.registrationForm.email]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "phone",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registrationForm.phone) = $event)),
                              placeholder: "Enter your Phone",
                              required: ""
                            }, null, 512), [
                              [_vModelText, _ctx.registrationForm.phone]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "phone",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registrationForm.national_id_no ) = $event)),
                              placeholder: "Enter your NID No",
                              required: ""
                            }, null, 512), [
                              [_vModelText, _ctx.registrationForm.national_id_no ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _withDirectives(_createElementVNode("textarea", {
                              type: "text",
                              class: "form-control",
                              id: "phone",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registrationForm.address) = $event)),
                              placeholder: "Enter your Address",
                              rows: "3"
                            }, null, 512), [
                              [_vModelText, _ctx.registrationForm.address]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("div", _hoisted_30, [
                              _withDirectives(_createElementVNode("input", {
                                type: _ctx.showPassword.new ? 'text' : 'password',
                                class: "form-control",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registrationForm.password) = $event)),
                                placeholder: "Enter password",
                                "aria-describedby": "password",
                                required: ""
                              }, null, 8, _hoisted_31), [
                                [_vModelDynamic, _ctx.registrationForm.password]
                              ]),
                              _createElementVNode("span", {
                                class: "input-group-text cursor-pointer",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.togglePassword('new')))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(_ctx.showPassword.new ? 'bx bx-show' : 'bx bx-hide')
                                }, null, 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("div", _hoisted_34, [
                              _withDirectives(_createElementVNode("input", {
                                type: _ctx.showPassword.confirm ? 'text' : 'password',
                                id: "password",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.registrationForm.password_confirmation) = $event)),
                                placeholder: "Confirm password",
                                required: ""
                              }, null, 8, _hoisted_35), [
                                [_vModelDynamic, _ctx.registrationForm.password_confirmation]
                              ]),
                              _createElementVNode("span", {
                                class: "input-group-text cursor-pointer",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.togglePassword('confirm')))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(_ctx.showPassword.confirm ? 'bx bx-show' : 'bx bx-hide')
                                }, null, 2)
                              ])
                            ])
                          ]),
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn btn-primary w-100 justify-content-center",
                              disabled: _ctx.submitBtn
                            }, [
                              (!_ctx.submitBtn)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Registration"))
                                : _createCommentVNode("", true),
                              (_ctx.submitBtn)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40))
                                : _createCommentVNode("", true),
                              (_ctx.submitBtn)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, " Loading ...."))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_38)
                          ])
                        ], 32),
                        _createElementVNode("p", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm",
                            style: {"color":"#696cff"},
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.switchToLogin()))
                          }, _hoisted_45)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}